import { render } from "./SettingPanel.vue?vue&type=template&id=00d3bad4&scoped=true&ts=true"
import script from "./SettingPanel.vue?vue&type=script&lang=ts"
export * from "./SettingPanel.vue?vue&type=script&lang=ts"

import "./SettingPanel.vue?vue&type=style&index=0&id=00d3bad4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00d3bad4"]])

export default __exports__